import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { createPackagingGeneral } from '../../../services/settings/inventory';
import Modal from '../../../component/modal/Modal';
import InputField from '../../../component/form/FormInput';
import Button from '../../../component/ui/Button';

export default function AddPackagingModel({
	setIsOpenModal,
	getList,
	isOpenModal,
	setPackagingOption,
	setFormData,
	setPackagingFocus,
}) {
	const [packagingForm, setPackagingForm] = useState({
		name: '',
		short_name: '',
		is_active: true,
	});
	const [error, setError] = useState({});
	const [packagingLoader, setPackagingLoader] = useState(false);

	const handleFormData = (key, value, required) => {
		setPackagingForm((prev) => ({
			...prev,
			[key]: value,
		}));

		if (required) {
			var newError = { ...error };
			if (value === '' || value === null || value === undefined) {
				newError[key] = `Please enter valid ${key.split('-').join('')} in the field`;
			} else {
				delete newError[key];
			}
			setError(newError);
		}
	};

	function checkValidation() {
		const newError = { ...error };

		if (!packagingForm.name || packagingForm.name === '' || packagingForm.name === undefined) {
			newError.name = newError.name || 'Please enter package name in the field';
		} else {
			delete newError.name;
		}

		if (Object.keys(newError).length > 0) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	const handlePackagingGeneral = async () => {
		let isError = checkValidation();
		if (isError) {
			return toast.error(`Packaging create failed! Please fill required fields.`);
		} else {
			try {
				setPackagingLoader(true);
				var body = {
					name: packagingForm.name,
					short_name: packagingForm.short_name,
					is_active: packagingForm.is_active,
				};

				const res = await createPackagingGeneral(body);

				if (res.success) {
					const { data } = res;
					if (res.data.pkg.is_active) {
						setFormData((prev) => ({
							...prev,
							packaging_id: data?.pkg?.id || '',
						}));
						const list = [
							{
								key: data?.pkg?.id || '',
								value: packagingForm.name,
							},
						];
						setPackagingOption(list);
					}
					setPackagingFocus(true);
					getList();
					setIsOpenModal(false);
					toast.success(res.message);
				} else {
					toast.error(res.message);
				}
			} catch (error) {
				toast.error(error.message || 'Something went wrong!');
			} finally {
				setPackagingLoader(false);
			}
		}
	};
	return (
		<Modal
			className="currency_model"
			title={`Add New Packaging`}
			isOpen={isOpenModal}
			onClose={() => {
				setIsOpenModal(false);
			}}
			cancelButton={() => {
				setIsOpenModal(false);
			}}
		>
			<div className="d-flex my-3 gap-2">
				<div className="col-6">
					<InputField
						label="Packaging Name"
						placeholder="Packaging name"
						autoFocus={true}
						type="text"
						required={true}
						value={packagingForm.name}
						onChange={(value) => handleFormData('name', value, true)}
						error={error?.name}
					/>
				</div>
				<div className="col-6">
					<InputField
						label="Short Name"
						placeholder="Short name"
						type="text"
						required={false}
						value={packagingForm.short_name}
						onChange={(value) => handleFormData('short_name', value)}
						error={error?.short_name}
					/>
				</div>
			</div>
			<div className="d-flex gap-3 align-items-center my-2">
				<div className="fs-5 fw-semibold text-dark">Active</div>
				<div className="form-check">
					<input
						class="form-check-input"
						type="checkbox"
						checked={packagingForm.is_active}
						id="flexCheckDefault"
						onChange={(e) => handleFormData('is_active', !packagingForm.is_active)}
					/>
				</div>
			</div>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'end',
					marginTop: '10px',
					gap: '10px',
				}}
			>
				<Button
					type="button"
					button={`Save`}
					disabled={packagingLoader}
					className="mt-0 px-4 btn-primary relative"
					onClick={() => handlePackagingGeneral()}
					loader={packagingLoader}
				/>
				<Button
					type="button"
					button={`Cancel`}
					className="mt-0 px-4 btn-gray relative"
					onClick={() => setIsOpenModal(false)}
				/>
			</div>
		</Modal>
	);
}
